// src/components/Shared/FooterGuest.jsx
import React from 'react';
import "../../styles/Login.css"; 

export default function FooterGuest() {
  return (
    <div className="footer bar-header-footer">
      <div className="container-box">
        <p className="text">
        ¿Te gustaría vender tus productos? Únete a la familia MercanteoMéxico. 
        Descarga nuestra app móvil y comienza a publicitarte hoy mismo.
        </p>
      </div>
    </div>
  );
}